export namespace ProfileStateActions {
    export class ToggleMenu {
        public static readonly type = "[Profile] ToggleMenu";
    }

    export class HideMenu {
        public static readonly type = "[Profile] HideMenu";
    }
}
